"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonExamType = exports.LessonExamScalarFieldEnum = exports.LessonExamQuestionScalarFieldEnum = exports.LessonCreatorScalarFieldEnum = exports.LessonCreaterSource = exports.JsonNullValueInput = exports.JsonNullValueFilter = exports.JobTransactionScalarFieldEnum = exports.JobReviewScalarFieldEnum = exports.JobOutputScalarFieldEnum = exports.JobOfferScalarFieldEnum = exports.JobOfferResponseScalarFieldEnum = exports.HashTagScalarFieldEnum = exports.FollowScalarFieldEnum = exports.FaQScalarFieldEnum = exports.ExternalRequestScalarFieldEnum = exports.ExpertInfoScalarFieldEnum = exports.DynamicLinkScalarFieldEnum = exports.DontShowAgainScalarFieldEnum = exports.DocumentScalarFieldEnum = exports.DeviceToken_TopicsScalarFieldEnum = exports.DeviceTokenInputMode = exports.DeletedUserScalarFieldEnum = exports.CustomerRelationshipScalarFieldEnum = exports.CustomerCommunicationLogScalarFieldEnum = exports.CommerceProductScalarFieldEnum = exports.CommerceProductReviewScalarFieldEnum = exports.CommerceOrderScalarFieldEnum = exports.CommerceOrderReviewScalarFieldEnum = exports.ClientVersionsScalarFieldEnum = exports.ChatRoomScalarFieldEnum = exports.ChannelUserUsageScalarFieldEnum = exports.ChannelScalarFieldEnum = exports.ChannelExpertScalarFieldEnum = exports.ChannelDictionaryScalarFieldEnum = exports.ChannelDeviceTokenScalarFieldEnum = exports.ChannelChatRoomMenuScalarFieldEnum = exports.ChannelBizInfoScalarFieldEnum = exports.CategoryScalarFieldEnum = exports.CategoryKeywordScalarFieldEnum = exports.BannedWordsScalarFieldEnum = exports.AttachmentScalarFieldEnum = exports.ApplicationsScalarFieldEnum = exports.AppInfoScalarFieldEnum = exports.AiChatRoomScalarFieldEnum = exports.AiChatMessageScalarFieldEnum = exports.AdvertiserScalarFieldEnum = exports.AdvertisementScalarFieldEnum = exports.AccountInfoScalarFieldEnum = exports.AbusingReportScalarFieldEnum = void 0;
exports.SysInfoScalarFieldEnum = exports.SubscriptionScalarFieldEnum = exports.SubscriptionHistoryScalarFieldEnum = exports.SortOrder = exports.SignInTelVerificationScalarFieldEnum = exports.SignInScalarFieldEnum = exports.SettlementScalarFieldEnum = exports.SettlementItemScalarFieldEnum = exports.ServerErrorScalarFieldEnum = exports.SecretScalarFieldEnum = exports.SearchWordScalarFieldEnum = exports.ReportActionScalarFieldEnum = exports.ReactionScalarFieldEnum = exports.QuotaUsageScalarFieldEnum = exports.QuotaScalarFieldEnum = exports.QueryMode = exports.Profile_ChatRoomScalarFieldEnum = exports.Profile_ChannelScalarFieldEnum = exports.Profile_ChannelActivityScalarFieldEnum = exports.ProfileScalarFieldEnum = exports.ProfileReviewScalarFieldEnum = exports.ProfileInfoScalarFieldEnum = exports.ProfileChannel_UserScalarFieldEnum = exports.ProductScalarFieldEnum = exports.PluginScalarFieldEnum = exports.PlaceScalarFieldEnum = exports.PaymentStatusHistoryScalarFieldEnum = exports.PaymentScalarFieldEnum = exports.PaymentIntentScalarFieldEnum = exports.PaymentApiFailureLogScalarFieldEnum = exports.NullsOrder = exports.NullableJsonNullValueInput = exports.MessageTranslationScalarFieldEnum = exports.MessageInfoScalarFieldEnum = exports.MesgNotificationScalarFieldEnum = exports.LessonYouTubeUserScalarFieldEnum = exports.LessonWatchHistoryScalarFieldEnum = exports.LessonVideoType = exports.LessonVideoSource = exports.LessonVideoScalarFieldEnum = exports.LessonUser_FlashcardDeckScalarFieldEnum = exports.LessonUnitType = exports.LessonUnitScalarFieldEnum = exports.LessonSubjectScalarFieldEnum = exports.LessonKeywordScalarFieldEnum = exports.LessonItemGroupScalarFieldEnum = exports.LessonFlashcardType = exports.LessonFlashcardScalarFieldEnum = exports.LessonFlashcardDeckScalarFieldEnum = exports.LessonFlashcardDeckMode = void 0;
exports.VersionChangeScalarFieldEnum = exports.User_ProfileScalarFieldEnum = exports.User_ChatRoomViewScalarFieldEnum = exports.UserUsageScalarFieldEnum = exports.UserScalarFieldEnum = exports.UserPointWithdrawRequestScalarFieldEnum = exports.UserPointLogScalarFieldEnum = exports.UserPenaltyScalarFieldEnum = exports.UserLogScalarFieldEnum = exports.UserKeywordScalarFieldEnum = exports.UserIdentityScalarFieldEnum = exports.UserChannelAccountScalarFieldEnum = exports.UserBlockingScalarFieldEnum = exports.UserAdActionScalarFieldEnum = exports.UrlMetadataScalarFieldEnum = exports.TransactionIsolationLevel = exports.ThumbnailScalarFieldEnum = exports.SysPictureScalarFieldEnum = exports.SysNotificationScalarFieldEnum = exports.SysNoticeScalarFieldEnum = void 0;
exports.AbusingReportScalarFieldEnum = {
    ChannelId: 'channelId',
    ChatRoomId: 'chatRoomId',
    ClosedAt: 'closedAt',
    CreatedAt: 'createdAt',
    Description: 'description',
    Id: 'id',
    LastActionAt: 'lastActionAt',
    MessageId: 'messageId',
    ProfileId: 'profileId',
    ReactionId: 'reactionId',
    ReporterId: 'reporterId',
    UserId: 'userId'
};
exports.AccountInfoScalarFieldEnum = {
    BankAccountHolder: 'bankAccountHolder',
    BankAccountNo: 'bankAccountNo',
    BankCode: 'bankCode',
    BankName: 'bankName',
    Id: 'id',
    ProfileId: 'profileId',
    TaxType: 'taxType',
    UserId: 'userId'
};
exports.AdvertisementScalarFieldEnum = {
    AdvertiserId: 'advertiserId',
    ByChannel: 'byChannel',
    ChannelId: 'channelId',
    Contents: 'contents',
    CreatedAt: 'createdAt',
    Id: 'id',
    IsAppChannel: 'isAppChannel',
    Title: 'title',
    ValidFrom: 'validFrom',
    ValidTo: 'validTo'
};
exports.AdvertiserScalarFieldEnum = {
    BizId: 'bizId',
    Email: 'email',
    Id: 'id',
    Name: 'name',
    RegId: 'regId',
    Tel: 'tel'
};
exports.AiChatMessageScalarFieldEnum = {
    Body: 'body',
    ChannelId: 'channelId',
    ChatRoomId: 'chatRoomId',
    CreatedAt: 'createdAt',
    Id: 'id',
    ImageUrl: 'imageUrl',
    InputTokens: 'inputTokens',
    IsFirst: 'isFirst',
    OutputTokens: 'outputTokens',
    Props: 'props',
    ResponseId: 'responseId',
    Role: 'role',
    UserId: 'userId'
};
exports.AiChatRoomScalarFieldEnum = {
    Category: 'category',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Id: 'id',
    LastAccessedAt: 'lastAccessedAt',
    UserId: 'userId'
};
exports.AppInfoScalarFieldEnum = {
    AndroidFingerprints: 'androidFingerprints',
    AndroidPackageId: 'androidPackageId',
    AppId: 'appId',
    AppName: 'appName',
    ChannelId: 'channelId',
    Id: 'id',
    IosAppStoreId: 'iosAppStoreId',
    IosBundleId: 'iosBundleId',
    IosTeamId: 'iosTeamId',
    WebAppUrl: 'webAppUrl'
};
exports.ApplicationsScalarFieldEnum = {
    AppId: 'appId',
    AppSecret: 'appSecret',
    Blocked: 'blocked',
    CreatedAt: 'createdAt',
    Id: 'id',
    LastAccessedAt: 'lastAccessedAt',
    Name: 'name',
    Polices: 'polices'
};
exports.AttachmentScalarFieldEnum = {
    Embed: 'embed',
    ExpertInfoId: 'expertInfoId',
    Id: 'id',
    Info: 'info',
    Size: 'size',
    Thumbnail: 'thumbnail',
    ThumbnailId: 'thumbnailId',
    Title: 'title',
    Type: 'type',
    Url: 'url'
};
exports.BannedWordsScalarFieldEnum = {
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Id: 'id',
    UpdatedAt: 'updatedAt',
    Words: 'words'
};
exports.CategoryKeywordScalarFieldEnum = {
    Id: 'id',
    Keyword: 'keyword'
};
exports.CategoryScalarFieldEnum = {
    ChannelId: 'channelId',
    Id: 'id',
    Name: 'name',
    Type: 'type'
};
exports.ChannelBizInfoScalarFieldEnum = {
    BankAccountHolder: 'bankAccountHolder',
    BankAccountNo: 'bankAccountNo',
    BankCode: 'bankCode',
    BankName: 'bankName',
    BizId: 'bizId',
    ChannelId: 'channelId',
    Commission: 'commission',
    CreatedAt: 'createdAt',
    Id: 'id',
    UpdatedAt: 'updatedAt'
};
exports.ChannelChatRoomMenuScalarFieldEnum = {
    ChannelId: 'channelId',
    ChatRoomId: 'chatRoomId',
    Id: 'id',
    Seq: 'seq',
    Text: 'text',
    Type: 'type'
};
exports.ChannelDeviceTokenScalarFieldEnum = {
    ChannelId: 'channelId',
    DeviceType: 'deviceType',
    Id: 'id',
    Lang: 'lang',
    Token: 'token',
    UserId: 'userId',
    Version: 'version'
};
exports.ChannelDictionaryScalarFieldEnum = {
    ChannelId: 'channelId',
    Dict: 'dict',
    Id: 'id',
    Lang: 'lang'
};
exports.ChannelExpertScalarFieldEnum = {
    ChannelId: 'channelId',
    CollectedInfo: 'collectedInfo',
    Description: 'description',
    Disabled: 'disabled',
    ExpertPolicy: 'expertPolicy',
    Id: 'id',
    IsOpen: 'isOpen',
    Name: 'name'
};
exports.ChannelScalarFieldEnum = {
    AccessCode: 'accessCode',
    ActionButtons: 'actionButtons',
    BlockSearch: 'blockSearch',
    CertificationNotice: 'certificationNotice',
    ChannelRoomId: 'channelRoomId',
    Code: 'code',
    CommerceProductMeta: 'commerceProductMeta',
    Company: 'company',
    CreatedAt: 'createdAt',
    DefaultSubscProductId: 'defaultSubscProductId',
    Description: 'description',
    ExpertName: 'expertName',
    Id: 'id',
    IsCompanyOperated: 'isCompanyOperated',
    Keywords: 'keywords',
    Layout: 'layout',
    MatchKeywords: 'matchKeywords',
    Name: 'name',
    NeedAccessCode: 'needAccessCode',
    NeedApproval: 'needApproval',
    OwnUserId: 'ownUserId',
    OwnerId: 'ownerId',
    Picture: 'picture',
    PrivacyPolicy: 'privacyPolicy',
    ProductMeta: 'productMeta',
    ProfileCount: 'profileCount',
    Props: 'props',
    TermsOfService: 'termsOfService',
    ThumbnailId: 'thumbnailId',
    Timestamp: 'timestamp',
    UiComponents: 'uiComponents',
    WelcomeMesg: 'welcomeMesg'
};
exports.ChannelUserUsageScalarFieldEnum = {
    ChannelId: 'channelId',
    Data: 'data',
    Id: 'id',
    ReadReactionId: 'readReactionId',
    UserId: 'userId'
};
exports.ChatRoomScalarFieldEnum = {
    AccessCode: 'accessCode',
    ChannelId: 'channelId',
    CommentsRootChatRoomId: 'commentsRootChatRoomId',
    CommentsRootMessageId: 'commentsRootMessageId',
    Description: 'description',
    Id: 'id',
    Keywords: 'keywords',
    Name: 'name',
    Namespace: 'namespace',
    Process: 'process',
    Props: 'props',
    Restricted: 'restricted',
    RootMessageId: 'rootMessageId',
    Status: 'status',
    Type: 'type'
};
exports.ClientVersionsScalarFieldEnum = {
    Android: 'android',
    Id: 'id',
    Ios: 'ios'
};
exports.CommerceOrderReviewScalarFieldEnum = {
    CreatedAt: 'createdAt',
    DeletedAt: 'deletedAt',
    Description: 'description',
    Id: 'id',
    OrderId: 'orderId',
    Point: 'point',
    ProductId: 'productId',
    ReviewerId: 'reviewerId',
    ReviewerUserId: 'reviewerUserId',
    SellerUserId: 'sellerUserId',
    UpdatedAt: 'updatedAt'
};
exports.CommerceOrderScalarFieldEnum = {
    CancelledAt: 'cancelledAt',
    ChannelId: 'channelId',
    ConfirmedAt: 'confirmedAt',
    CreatedAt: 'createdAt',
    Currency: 'currency',
    DownloadedAt: 'downloadedAt',
    Id: 'id',
    LastPaidAt: 'lastPaidAt',
    NeedConfirm: 'needConfirm',
    OrderDetail: 'orderDetail',
    PaidByPoint: 'paidByPoint',
    PaidExt: 'paidExt',
    PaidPoint: 'paidPoint',
    PriceExt: 'priceExt',
    ProductId: 'productId',
    ProductType: 'productType',
    ProfileId: 'profileId',
    ReceivedAt: 'receivedAt',
    RefundExt: 'refundExt',
    RefundedAt: 'refundedAt',
    RefundedExt: 'refundedExt',
    RiderId: 'riderId',
    RiderUserId: 'riderUserId',
    ScheduledAt: 'scheduledAt',
    SellerId: 'sellerId',
    SellerUserId: 'sellerUserId',
    SentAt: 'sentAt',
    SettlePlatformId: 'settlePlatformId',
    SettleProviderId: 'settleProviderId',
    SettlementId: 'settlementId',
    State: 'state',
    SubscTransactionId: 'subscTransactionId',
    TempSettlementId: 'tempSettlementId',
    ToBePaidExt: 'toBePaidExt',
    ToBeRefunded: 'toBeRefunded',
    UpdatedAt: 'updatedAt',
    UserId: 'userId',
    UserUuid: 'userUuid'
};
exports.CommerceProductReviewScalarFieldEnum = {
    CreatedAt: 'createdAt',
    DeletedAt: 'deletedAt',
    Description: 'description',
    Id: 'id',
    Point: 'point',
    ProductId: 'productId',
    ReviewerId: 'reviewerId',
    ReviewerUserId: 'reviewerUserId',
    SellerUserId: 'sellerUserId',
    UpdatedAt: 'updatedAt'
};
exports.CommerceProductScalarFieldEnum = {
    Attachments: 'attachments',
    Cat: 'cat',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Currency: 'currency',
    Desc: 'desc',
    DigitalFiles: 'digitalFiles',
    ExtProductRef: 'extProductRef',
    ExtraTerms: 'extraTerms',
    Id: 'id',
    Name: 'name',
    PriceExt: 'priceExt',
    QuotaSpecs: 'quotaSpecs',
    Review: 'review',
    ReviewCount: 'reviewCount',
    SellerId: 'sellerId',
    SellerUserId: 'sellerUserId',
    SoldCount: 'soldCount',
    Specs: 'specs',
    Sub: 'sub',
    Thumbnails: 'thumbnails',
    Type: 'type',
    UpdatedAt: 'updatedAt'
};
exports.CustomerCommunicationLogScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Id: 'id',
    Memo: 'memo',
    Rejected: 'rejected',
    RelationshipId: 'relationshipId',
    StageChanged: 'stageChanged',
    Title: 'title',
    Type: 'type',
    When: 'when',
    Where: 'where',
    Who: 'who'
};
exports.CustomerRelationshipScalarFieldEnum = {
    Bookmarked: 'bookmarked',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    CustomerPcId: 'customerPcId',
    Grade: 'grade',
    HadDeal: 'hadDeal',
    Id: 'id',
    Rejected: 'rejected',
    Stage: 'stage',
    Tags: 'tags',
    UserId: 'userId',
    UserPcId: 'userPcId',
    WasConnected: 'wasConnected'
};
exports.DeletedUserScalarFieldEnum = {
    DeletedAt: 'deletedAt',
    Id: 'id',
    Penalty: 'penalty',
    Reason: 'reason',
    Tel: 'tel'
};
exports.DeviceTokenInputMode = {
    Add: 'Add',
    Delete: 'Delete'
};
exports.DeviceToken_TopicsScalarFieldEnum = {
    CreatedAt: 'createdAt',
    DeletedAt: 'deletedAt',
    Id: 'id',
    Token: 'token',
    Topics: 'topics',
    UpdatedAt: 'updatedAt'
};
exports.DocumentScalarFieldEnum = {
    ChannelId: 'channelId',
    Content: 'content',
    Id: 'id',
    Lang: 'lang',
    Type: 'type',
    Version: 'version'
};
exports.DontShowAgainScalarFieldEnum = {
    Id: 'id',
    Name: 'name',
    Type: 'type',
    UserId: 'userId'
};
exports.DynamicLinkScalarFieldEnum = {
    CreatedAt: 'createdAt',
    ExpiresAt: 'expiresAt',
    Fingerprint: 'fingerprint',
    Id: 'id',
    Ip: 'ip',
    IsMobile: 'isMobile',
    IsSafari: 'isSafari',
    IsUsed: 'isUsed',
    Platform: 'platform',
    Url: 'url',
    UsedAt: 'usedAt'
};
exports.ExpertInfoScalarFieldEnum = {
    AgreePolicyAt: 'agreePolicyAt',
    AgreePrivacyAt: 'agreePrivacyAt',
    ApprovedAt: 'approvedAt',
    ChannelExpertId: 'channelExpertId',
    ChannelId: 'channelId',
    DeniedAt: 'deniedAt',
    DenyReason: 'denyReason',
    Description: 'description',
    Id: 'id',
    ProfileChannelId: 'profile_ChannelId',
    ReRequestedAt: 'reRequestedAt',
    RequestedAt: 'requestedAt',
    UserId: 'userId'
};
exports.ExternalRequestScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Error: 'error',
    Id: 'id',
    RepliedAt: 'repliedAt',
    Reply: 'reply',
    Request: 'request',
    Success: 'success',
    Type: 'type'
};
exports.FaQScalarFieldEnum = {
    Answer: 'answer',
    Category: 'category',
    Id: 'id',
    Question: 'question',
    Seq: 'seq'
};
exports.FollowScalarFieldEnum = {
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    FollowerId: 'followerId',
    Id: 'id',
    UserId: 'userId'
};
exports.HashTagScalarFieldEnum = {
    ChannelId: 'channelId',
    Count: 'count',
    Id: 'id',
    Name: 'name'
};
exports.JobOfferResponseScalarFieldEnum = {
    CanceledAt: 'canceledAt',
    CanceledBy: 'canceledBy',
    ChannelId: 'channelId',
    ChatRoomId: 'chatRoomId',
    ClientId: 'clientId',
    ClientUserId: 'clientUserId',
    CreatedAt: 'createdAt',
    Currency: 'currency',
    Duration: 'duration',
    FinishedAt: 'finishedAt',
    HiredAt: 'hiredAt',
    Id: 'id',
    IsPublicByClient: 'isPublicByClient',
    IsPublicByProvider: 'isPublicByProvider',
    JobOfferId: 'jobOfferId',
    OfferChatRoomId: 'offerChatRoomId',
    PaidByPoint: 'paidByPoint',
    PaidExt: 'paidExt',
    PaidPoint: 'paidPoint',
    PartsApplied: 'partsApplied',
    PartsHired: 'partsHired',
    Price: 'price',
    PriceExt: 'priceExt',
    Props: 'props',
    ProviderId: 'providerId',
    ProviderUserId: 'providerUserId',
    Refund: 'refund',
    RefundAgreedAt: 'refundAgreedAt',
    RefundExt: 'refundExt',
    RefundedExt: 'refundedExt',
    SettlePlatformId: 'settlePlatformId',
    SettleProviderId: 'settleProviderId',
    SettlementId: 'settlementId',
    StartAt: 'startAt',
    State: 'state',
    TempSettlementId: 'tempSettlementId',
    ToBeDoneByClient: 'toBeDoneByClient',
    ToBeDoneByProvider: 'toBeDoneByProvider',
    ToBePaid: 'toBePaid',
    ToBePaidExt: 'toBePaidExt',
    ToBeRefunded: 'toBeRefunded'
};
exports.JobOfferScalarFieldEnum = {
    ChannelId: 'channelId',
    ChatRoomId: 'chatRoomId',
    ClientId: 'clientId',
    ClientUserId: 'clientUserId',
    CountsHired: 'countsHired',
    CreatedAt: 'createdAt',
    DesignatedProviderId: 'designatedProviderId',
    DesignatedProviderUserId: 'designatedProviderUserId',
    GroupChatRoomId: 'groupChatRoomId',
    Id: 'id',
    IsPublic: 'isPublic',
    IsPublicByClient: 'isPublicByClient',
    JobReward: 'jobReward',
    MesgId: 'mesgId',
    PartsAndCounts: 'partsAndCounts',
    Props: 'props',
    State: 'state'
};
exports.JobOutputScalarFieldEnum = {
    ChannelId: 'channelId',
    ChatRoomId: 'chatRoomId',
    ClientId: 'clientId',
    ClientUserId: 'clientUserId',
    CreatedAt: 'createdAt',
    Group: 'group',
    Id: 'id',
    JobOfferId: 'jobOfferId',
    JobOfferResponseId: 'jobOfferResponseId',
    Keywords: 'keywords',
    MesgKeywords: 'mesgKeywords',
    MessageId: 'messageId',
    Props: 'props',
    ProviderId: 'providerId',
    ProviderUserId: 'providerUserId',
    Published: 'published',
    PublishedByClient: 'publishedByClient',
    PublishedByProvider: 'publishedByProvider',
    Title: 'title',
    Type: 'type',
    WhoCanPublish: 'whoCanPublish'
};
exports.JobReviewScalarFieldEnum = {
    ChannelId: 'channelId',
    ChatRoomId: 'chatRoomId',
    CreatedAt: 'createdAt',
    Detail: 'detail',
    Id: 'id',
    JobAsClientId: 'jobAsClientId',
    JobAsProviderId: 'jobAsProviderId',
    OfferChatRoomId: 'offerChatRoomId',
    Point1: 'point1',
    Point2: 'point2',
    Point3: 'point3',
    PointOverall: 'pointOverall',
    RevieweeId: 'revieweeId',
    RevieweeUserId: 'revieweeUserId',
    ReviewerId: 'reviewerId',
    ReviewerUserId: 'reviewerUserId',
    Role: 'role'
};
exports.JobTransactionScalarFieldEnum = {
    Body: 'body',
    CreatedAt: 'createdAt',
    Id: 'id',
    JobOfferResponseId: 'jobOfferResponseId',
    MesgId: 'mesgId',
    Type: 'type'
};
exports.JsonNullValueFilter = {
    AnyNull: 'AnyNull',
    DbNull: 'DbNull',
    JsonNull: 'JsonNull'
};
exports.JsonNullValueInput = {
    JsonNull: 'JsonNull'
};
exports.LessonCreaterSource = {
    Beezvalley: 'beezvalley',
    Youtube: 'youtube'
};
exports.LessonCreatorScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Id: 'id',
    ProfileId: 'profileId',
    Source: 'source',
    UpdatedAt: 'updatedAt',
    UserId: 'userId',
    Uuid: 'uuid',
    YoutubeUserId: 'youtubeUserId'
};
exports.LessonExamQuestionScalarFieldEnum = {
    Answer: 'answer',
    Audio: 'audio',
    Content: 'content',
    CreatedAt: 'createdAt',
    DeletedAt: 'deletedAt',
    ExamUuid: 'examUuid',
    Explanation: 'explanation',
    Id: 'id',
    Keywords: 'keywords',
    MesgId: 'mesgId',
    Number: 'number',
    Point: 'point',
    UnitIds: 'unitIds',
    UpdatedAt: 'updatedAt',
    Uuid: 'uuid'
};
exports.LessonExamScalarFieldEnum = {
    CreatedAt: 'createdAt',
    DeletedAt: 'deletedAt',
    Grade: 'grade',
    Id: 'id',
    Month: 'month',
    SubjectId: 'subjectId',
    Title: 'title',
    Type: 'type',
    UpdatedAt: 'updatedAt',
    Uuid: 'uuid',
    Year: 'year'
};
exports.LessonExamType = {
    Suneung: 'suneung',
    Trial: 'trial'
};
exports.LessonFlashcardDeckMode = {
    Anki: 'anki',
    Loop: 'loop',
    Sequence: 'sequence'
};
exports.LessonFlashcardDeckScalarFieldEnum = {
    CardUuids: 'cardUuids',
    CommerceProductId: 'commerceProductId',
    CoverUrl: 'coverUrl',
    CreatedAt: 'createdAt',
    CreatorUuid: 'creatorUuid',
    DeletedAt: 'deletedAt',
    Description: 'description',
    Difficulty: 'difficulty',
    Id: 'id',
    Title: 'title',
    Type: 'type',
    UnitIds: 'unitIds',
    UpdatedAt: 'updatedAt',
    Uuid: 'uuid'
};
exports.LessonFlashcardScalarFieldEnum = {
    Answers: 'answers',
    Content: 'content',
    CreatedAt: 'createdAt',
    CreatorUuid: 'creatorUuid',
    DeletedAt: 'deletedAt',
    Explanation: 'explanation',
    Id: 'id',
    Keywords: 'keywords',
    MesgId: 'mesgId',
    Props: 'props',
    Type: 'type',
    UnitIds: 'unitIds',
    UpdatedAt: 'updatedAt',
    Uuid: 'uuid',
    Wrongs: 'wrongs'
};
exports.LessonFlashcardType = {
    Blank: 'blank',
    Grammar: 'grammar',
    Ox: 'ox',
    Word: 'word'
};
exports.LessonItemGroupScalarFieldEnum = {
    Id: 'id',
    Title: 'title'
};
exports.LessonKeywordScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Description: 'description',
    Id: 'id',
    Keyword: 'keyword',
    UpdatedAt: 'updatedAt',
    Url: 'url'
};
exports.LessonSubjectScalarFieldEnum = {
    Id: 'id',
    Title: 'title'
};
exports.LessonUnitScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Id: 'id',
    Index: 'index',
    Level: 'level',
    SubjectId: 'subjectId',
    SuperUnitId: 'superUnitId',
    Title: 'title',
    Type: 'type',
    UpdatedAt: 'updatedAt'
};
exports.LessonUnitType = {
    ExamQuestion: 'examQuestion',
    Flashcard: 'flashcard',
    Video: 'video'
};
exports.LessonUser_FlashcardDeckScalarFieldEnum = {
    CommerceOrderId: 'commerceOrderId',
    CommerceProductId: 'commerceProductId',
    Comprehension: 'comprehension',
    CreatedAt: 'createdAt',
    DeckUuid: 'deckUuid',
    DeletedAt: 'deletedAt',
    Id: 'id',
    LastAccessedAt: 'lastAccessedAt',
    LastCardId: 'lastCardId',
    Mode: 'mode',
    Progress: 'progress',
    UpdatedAt: 'updatedAt',
    UserId: 'userId'
};
exports.LessonVideoScalarFieldEnum = {
    CreatedAt: 'createdAt',
    CreatorUuid: 'creatorUuid',
    DeletedAt: 'deletedAt',
    Description: 'description',
    Duration: 'duration',
    GroupId: 'groupId',
    Id: 'id',
    Images: 'images',
    IndexInGroup: 'indexInGroup',
    Keywords: 'keywords',
    LessonUuid: 'lessonUuid',
    MesgId: 'mesgId',
    PreviewClip: 'previewClip',
    Source: 'source',
    ThumbnailUrl: 'thumbnailUrl',
    Title: 'title',
    Type: 'type',
    UnitIds: 'unitIds',
    UpdatedAt: 'updatedAt',
    Uuid: 'uuid',
    VideoId: 'videoId'
};
exports.LessonVideoSource = {
    Beezvalley: 'beezvalley',
    Youtube: 'youtube'
};
exports.LessonVideoType = {
    Example: 'example',
    Lesson: 'lesson',
    Preview: 'preview'
};
exports.LessonWatchHistoryScalarFieldEnum = {
    CreatedAt: 'createdAt',
    DeletedAt: 'deletedAt',
    Id: 'id',
    LastWatchPosition: 'lastWatchPosition',
    LessonMesgId: 'lessonMesgId',
    LessonUuid: 'lessonUuid',
    TotalWatchTime: 'totalWatchTime',
    UpdatedAt: 'updatedAt',
    UserId: 'userId',
    WatchCount: 'watchCount'
};
exports.LessonYouTubeUserScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Id: 'id',
    Name: 'name',
    ThumbnailUrl: 'thumbnailUrl',
    UpdatedAt: 'updatedAt'
};
exports.MesgNotificationScalarFieldEnum = {
    ChatRoomId: 'chatRoomId',
    CreatedAt: 'createdAt',
    Id: 'id',
    MessageId: 'messageId',
    UserId: 'userId'
};
exports.MessageInfoScalarFieldEnum = {
    BookmarkCount: 'bookmarkCount',
    ChannelId: 'channelId',
    ChatRoomId: 'chatRoomId',
    CommentsChatRoomId: 'commentsChatRoomId',
    CommentsCount: 'commentsCount',
    Id: 'id',
    LikesCount: 'likesCount',
    NotiUserCount: 'notiUserCount',
    UserId: 'userId'
};
exports.MessageTranslationScalarFieldEnum = {
    Id: 'id',
    LastAccessedAt: 'lastAccessedAt',
    MesgId: 'mesgId',
    MesgT: 'mesgT',
    Target: 'target',
    Version: 'version'
};
exports.NullableJsonNullValueInput = {
    DbNull: 'DbNull',
    JsonNull: 'JsonNull'
};
exports.NullsOrder = {
    First: 'first',
    Last: 'last'
};
exports.PaymentApiFailureLogScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Params: 'params',
    PaymentId: 'paymentId',
    Response: 'response',
    UpdatedAt: 'updatedAt'
};
exports.PaymentIntentScalarFieldEnum = {
    ChannelId: 'channelId',
    CommerceProductId: 'commerceProductId',
    CreatedAt: 'createdAt',
    Id: 'id',
    Moid: 'moid',
    PayMethod: 'payMethod',
    PgVendor: 'pgVendor',
    Tid: 'tid',
    UserId: 'userId',
    UserUuid: 'userUuid'
};
exports.PaymentScalarFieldEnum = {
    Amount: 'amount',
    AmountForeign: 'amountForeign',
    ApprovedAt: 'approvedAt',
    ChannelId: 'channelId',
    CommerceOrderId: 'commerceOrderId',
    CreatedAt: 'createdAt',
    Currency: 'currency',
    Detail: 'detail',
    EventCode: 'eventCode',
    ExchRate: 'exchRate',
    FormData: 'formData',
    GoodName: 'goodName',
    Id: 'id',
    JobResponseId: 'jobResponseId',
    Moid: 'moid',
    PayMethod: 'payMethod',
    PgVendor: 'pgVendor',
    Refunded: 'refunded',
    RefundedForeign: 'refundedForeign',
    ResultCode: 'resultCode',
    ResultMsg: 'resultMsg',
    Status: 'status',
    SubscriptionId: 'subscriptionId',
    Tid: 'tid',
    UpdatedAt: 'updatedAt',
    UserId: 'userId'
};
exports.PaymentStatusHistoryScalarFieldEnum = {
    Amount: 'amount',
    CreatedAt: 'createdAt',
    Id: 'id',
    PaymentId: 'paymentId',
    Status: 'status',
    UpdatedAt: 'updatedAt'
};
exports.PlaceScalarFieldEnum = {
    Address: 'address',
    Category: 'category',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Description: 'description',
    Id: 'id',
    Latitude: 'latitude',
    Longitude: 'longitude',
    Name: 'name',
    Props: 'props',
    Region: 'region',
    SubCategory: 'subCategory',
    UpdatedAt: 'updatedAt'
};
exports.PluginScalarFieldEnum = {
    ApprovedAt: 'approvedAt',
    ChannelId: 'channelId',
    Id: 'id',
    RejectReason: 'rejectReason',
    RejectedAt: 'rejectedAt',
    Seq: 'seq',
    SubmitAt: 'submitAt',
    Title: 'title',
    Type: 'type',
    Uuid: 'uuid',
    Version: 'version'
};
exports.ProductScalarFieldEnum = {
    Cat: 'cat',
    ChannelId: 'channelId',
    Currency: 'currency',
    Desc: 'desc',
    Duration: 'duration',
    ExtraTerms: 'extraTerms',
    Id: 'id',
    Name: 'name',
    Price: 'price',
    PriceExt: 'priceExt',
    Sub: 'sub',
    Type: 'type'
};
exports.ProfileChannel_UserScalarFieldEnum = {
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    FirstViewAt: 'firstViewAt',
    Id: 'id',
    LatestViewAt: 'latestViewAt',
    ProfileChannelId: 'profileChannelId',
    UserId: 'userId',
    ViewCount: 'viewCount'
};
exports.ProfileInfoScalarFieldEnum = {
    Data: 'data',
    Id: 'id',
    ProfileId: 'profileId',
    Type: 'type'
};
exports.ProfileReviewScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Description: 'description',
    Id: 'id',
    PredefinedCode: 'predefinedCode',
    RevieweeId: 'revieweeId',
    ReviewerId: 'reviewerId',
    Role: 'role',
    Type: 'type'
};
exports.ProfileScalarFieldEnum = {
    Address: 'address',
    Attachments: 'attachments',
    BizId: 'bizId',
    BizName: 'bizName',
    BlockChatting: 'blockChatting',
    CanIssueReceipt: 'canIssueReceipt',
    Ceo: 'ceo',
    CreatedAt: 'createdAt',
    Deleted: 'deleted',
    Description: 'description',
    Email: 'email',
    Email2: 'email2',
    EmailCode: 'emailCode',
    EmailCodeValidUntil: 'emailCodeValidUntil',
    EmailVerified: 'emailVerified',
    Homepage: 'homepage',
    Id: 'id',
    Name: 'name',
    Picture: 'picture',
    Tel: 'tel',
    Tel2: 'tel2',
    TelCode: 'telCode',
    TelCodeValidUntil: 'telCodeValidUntil',
    TelVerified: 'telVerified',
    ThumbnailId: 'thumbnailId',
    Type: 'type',
    UserId: 'userId'
};
exports.Profile_ChannelActivityScalarFieldEnum = {
    AttendCount: 'attendCount',
    ChannelId: 'channelId',
    CustomPoint: 'customPoint',
    FollowerCount: 'followerCount',
    Id: 'id',
    LatestPointAt: 'latestPointAt',
    Level: 'level',
    Point: 'point',
    PointSpent: 'pointSpent',
    PointTerm: 'pointTerm',
    PostCount: 'postCount',
    ProfileChannelId: 'profileChannelId',
    Props: 'props',
    RatingCount: 'ratingCount',
    RecentAttendCount: 'recentAttendCount',
    RecentFollowerCount: 'recentFollowerCount',
    RecentPostCount: 'recentPostCount',
    RecentRatingCount: 'recentRatingCount',
    RecentReferCount: 'recentReferCount',
    RecentReviewCount: 'recentReviewCount',
    ReferCount: 'referCount',
    ResetAt: 'resetAt',
    ReviewCount: 'reviewCount',
    SubscInfo: 'subscInfo',
    SubscProductId: 'subscProductId',
    UserId: 'userId'
};
exports.Profile_ChannelScalarFieldEnum = {
    AgreePrivacyAt: 'agreePrivacyAt',
    AgreeTermsAt: 'agreeTermsAt',
    ApprovalRequestedAt: 'approvalRequestedAt',
    ApprovedAt: 'approvedAt',
    BlockChatting: 'blockChatting',
    CertRequestedAt: 'certRequestedAt',
    CertVerifiedAt: 'certVerifiedAt',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    CurrentExpertId: 'currentExpertId',
    CustodianId: 'custodianId',
    DenyReason: 'denyReason',
    ExpelledAt: 'expelledAt',
    FavoriteChatRooms: 'favoriteChatRooms',
    Id: 'id',
    IsAdmin: 'isAdmin',
    IsPublic: 'isPublic',
    MesgFilter: 'mesgFilter',
    MesgFilterTokens: 'mesgFilterTokens',
    Namespace: 'namespace',
    NoDefaultExpert: 'noDefaultExpert',
    PasswordApprovedChatRoomIds: 'passwordApprovedChatRoomIds',
    ProfileId: 'profileId',
    Props: 'props',
    ReferrerId: 'referrerId',
    ReviewAverage: 'reviewAverage',
    ReviewCount: 'reviewCount',
    SuspendUntil: 'suspendUntil',
    UserAttachments: 'userAttachments',
    UserId: 'userId',
    UserInfo: 'userInfo',
    ViewCount: 'viewCount'
};
exports.Profile_ChatRoomScalarFieldEnum = {
    ChatRoomId: 'chatRoomId',
    Id: 'id',
    ProfileId: 'profileId',
    Role: 'role',
    UserId: 'userId'
};
exports.QueryMode = {
    Default: 'default',
    Insensitive: 'insensitive'
};
exports.QuotaScalarFieldEnum = {
    Balance: 'balance',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Id: 'id',
    Limit: 'limit',
    PreUsed: 'preUsed',
    RevokedAt: 'revokedAt',
    SubscriptionId: 'subscriptionId',
    Type: 'type',
    UpdatedAt: 'updatedAt',
    UserId: 'userId',
    ValidFrom: 'validFrom',
    ValidTo: 'validTo'
};
exports.QuotaUsageScalarFieldEnum = {
    Amount: 'amount',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Id: 'id',
    ItemId: 'itemId',
    QuotaId: 'quotaId',
    Type: 'type',
    UserId: 'userId'
};
exports.ReactionScalarFieldEnum = {
    Censored: 'censored',
    ChannelId: 'channelId',
    ChatRoomId: 'chatRoomId',
    CreatedAt: 'createdAt',
    Id: 'id',
    LikesCount: 'likesCount',
    MesgId: 'mesgId',
    ParentReactionId: 'parentReactionId',
    ProfileName: 'profileName',
    Props: 'props',
    ReportedAt: 'reportedAt',
    TargetProfileName: 'targetProfileName',
    TargetUserId: 'targetUserId',
    Type: 'type',
    UpdatedAt: 'updatedAt',
    UserId: 'userId'
};
exports.ReportActionScalarFieldEnum = {
    AbusingReportId: 'abusingReportId',
    CreatedAt: 'createdAt',
    Description: 'description',
    Id: 'id',
    PenaltyId: 'penaltyId'
};
exports.SearchWordScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Id: 'id',
    UserId: 'userId',
    Words: 'words'
};
exports.SecretScalarFieldEnum = {
    Id: 'id',
    Key: 'key',
    Value: 'value'
};
exports.ServerErrorScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Id: 'id',
    Message: 'message',
    Type: 'type'
};
exports.SettlementItemScalarFieldEnum = {
    AmountCompany: 'amountCompany',
    AmountForeign: 'amountForeign',
    AmountPaid: 'amountPaid',
    AmountPg: 'amountPg',
    AmountPlatform: 'amountPlatform',
    AmountProvider: 'amountProvider',
    ChannelId: 'channelId',
    CommerceOrderId: 'commerceOrderId',
    CommerceProductId: 'commerceProductId',
    CreatedAt: 'createdAt',
    Currency: 'currency',
    CurrencyPaid: 'currencyPaid',
    ExchRate: 'exchRate',
    Id: 'id',
    JobOfferId: 'jobOfferId',
    JrspId: 'jrspId',
    PaidByPoint: 'paidByPoint',
    PaidPoint: 'paidPoint',
    PayMethod: 'payMethod',
    PgVendor: 'pgVendor',
    Price: 'price',
    RateCompany: 'rateCompany',
    RatePg: 'ratePg',
    RatePlatform: 'ratePlatform',
    RateProvider: 'rateProvider',
    SettlementId: 'settlementId',
    SubscriptionId: 'subscriptionId',
    Type: 'type',
    UserId: 'userId'
};
exports.SettlementScalarFieldEnum = {
    Amount: 'amount',
    AmountBeforeTax: 'amountBeforeTax',
    AmountWithTax: 'amountWithTax',
    BankAccountNo: 'bankAccountNo',
    BankCode: 'bankCode',
    ChannelId: 'channelId',
    Commissions: 'commissions',
    CountItem: 'countItem',
    CountOrder: 'countOrder',
    CreatedAt: 'createdAt',
    Id: 'id',
    Pg: 'pg',
    ProfileId: 'profileId',
    Response: 'response',
    Target: 'target',
    TaxAmount: 'taxAmount',
    TaxType: 'taxType',
    Tid: 'tid',
    TotalSalesAmount: 'totalSalesAmount',
    UserId: 'userId'
};
exports.SignInScalarFieldEnum = {
    DeviceId: 'deviceId',
    DeviceType: 'deviceType',
    Id: 'id',
    Token: 'token',
    UserId: 'userId',
    ValidUntil: 'validUntil'
};
exports.SignInTelVerificationScalarFieldEnum = {
    Code: 'code',
    Count: 'count',
    Id: 'id',
    Tel: 'tel',
    ValidUntil: 'validUntil'
};
exports.SortOrder = {
    Asc: 'asc',
    Desc: 'desc'
};
exports.SubscriptionHistoryScalarFieldEnum = {
    CancelReason: 'cancelReason',
    CancelledAt: 'cancelledAt',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Currency: 'currency',
    Details: 'details',
    ExternalProductId: 'externalProductId',
    HId: 'hId',
    HPreId: 'hPreId',
    HValidFrom: 'hValidFrom',
    HValidTo: 'hValidTo',
    Id: 'id',
    IsAutoRenewal: 'isAutoRenewal',
    IsOriginal: 'isOriginal',
    IsSandbox: 'isSandbox',
    NotificationId: 'notificationId',
    OriginalTransactionId: 'originalTransactionId',
    Payments: 'payments',
    PgVendor: 'pgVendor',
    PreTransactionId: 'preTransactionId',
    PriceExt: 'priceExt',
    Product: 'product',
    ProductId: 'productId',
    PurchaseToken: 'purchaseToken',
    QuotaSpecs: 'quotaSpecs',
    Seller: 'seller',
    SellerId: 'sellerId',
    SellerUserId: 'sellerUserId',
    SettleItem: 'settleItem',
    Status: 'status',
    TransactionId: 'transactionId',
    UpdatedAt: 'updatedAt',
    UserId: 'userId',
    UserToken: 'userToken',
    ValidFrom: 'validFrom',
    ValidTo: 'validTo'
};
exports.SubscriptionScalarFieldEnum = {
    CancelReason: 'cancelReason',
    CancelledAt: 'cancelledAt',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Currency: 'currency',
    Details: 'details',
    ExternalProductId: 'externalProductId',
    Id: 'id',
    IsAutoRenewal: 'isAutoRenewal',
    IsOriginal: 'isOriginal',
    IsSandbox: 'isSandbox',
    NotificationId: 'notificationId',
    OriginalTransactionId: 'originalTransactionId',
    PgVendor: 'pgVendor',
    PreTransactionId: 'preTransactionId',
    PriceExt: 'priceExt',
    ProductId: 'productId',
    PurchaseToken: 'purchaseToken',
    QuotaSpecs: 'quotaSpecs',
    SellerId: 'sellerId',
    SellerUserId: 'sellerUserId',
    Status: 'status',
    TransactionId: 'transactionId',
    UpdatedAt: 'updatedAt',
    UserId: 'userId',
    UserToken: 'userToken',
    ValidFrom: 'validFrom',
    ValidTo: 'validTo'
};
exports.SysInfoScalarFieldEnum = {
    Categories: 'categories',
    Commission: 'commission',
    CompanyInfo: 'companyInfo',
    Ext: 'ext',
    Forex: 'forex',
    Id: 'id',
    PluginUrlTemplate: 'pluginUrlTemplate',
    VersionAndroid: 'versionAndroid',
    VersionIos: 'versionIos'
};
exports.SysNoticeScalarFieldEnum = {
    ChannelId: 'channelId',
    Content: 'content',
    CreatedAt: 'createdAt',
    Html: 'html',
    Id: 'id',
    IsImportant: 'isImportant',
    Subject: 'subject'
};
exports.SysNotificationScalarFieldEnum = {
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Id: 'id',
    Info: 'info',
    ReceiverId: 'receiverId',
    ReceiverUserId: 'receiverUserId',
    Type: 'type'
};
exports.SysPictureScalarFieldEnum = {
    Id: 'id',
    ThumbnailId: 'thumbnailId',
    Type: 'type',
    Url: 'url'
};
exports.ThumbnailScalarFieldEnum = {
    Data: 'data',
    Id: 'id'
};
exports.TransactionIsolationLevel = {
    ReadCommitted: 'ReadCommitted',
    ReadUncommitted: 'ReadUncommitted',
    RepeatableRead: 'RepeatableRead',
    Serializable: 'Serializable'
};
exports.UrlMetadataScalarFieldEnum = {
    CreatedAt: 'createdAt',
    Data: 'data',
    Id: 'id',
    Url: 'url'
};
exports.UserAdActionScalarFieldEnum = {
    Action: 'action',
    AdId: 'adId',
    CreatedAt: 'createdAt',
    Id: 'id',
    RefererId: 'refererId',
    UserId: 'userId'
};
exports.UserBlockingScalarFieldEnum = {
    BlockeeId: 'blockeeId',
    BlockeeProfileId: 'blockeeProfileId',
    BlockerId: 'blockerId',
    CreatedAt: 'createdAt',
    Id: 'id'
};
exports.UserChannelAccountScalarFieldEnum = {
    Balance: 'balance',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Id: 'id',
    Provision: 'provision',
    UpdatedAt: 'updatedAt',
    UserId: 'userId'
};
exports.UserIdentityScalarFieldEnum = {
    Id: 'id',
    IdNo: 'idNo',
    Name: 'name',
    Tel: 'tel'
};
exports.UserKeywordScalarFieldEnum = {
    Id: 'id',
    Keywords: 'keywords',
    Locations: 'locations',
    UserId: 'userId'
};
exports.UserLogScalarFieldEnum = {
    Body: 'body',
    CreatedAt: 'createdAt',
    Id: 'id',
    Type: 'type',
    UserId: 'userId',
    Uuid: 'uuid'
};
exports.UserPenaltyScalarFieldEnum = {
    AcknowledgedAt: 'acknowledgedAt',
    CreatedAt: 'createdAt',
    Hours: 'hours',
    Id: 'id',
    Props: 'props',
    Reason: 'reason',
    Type: 'type',
    UserId: 'userId'
};
exports.UserPointLogScalarFieldEnum = {
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Id: 'id',
    Point: 'point',
    Reason: 'reason',
    UserId: 'userId'
};
exports.UserPointWithdrawRequestScalarFieldEnum = {
    CanceledAt: 'canceledAt',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Id: 'id',
    Note: 'note',
    Point: 'point',
    UserId: 'userId',
    WithdrewAt: 'withdrewAt'
};
exports.UserScalarFieldEnum = {
    AgreeToMarketingAt: 'agreeToMarketingAt',
    AuxInfo: 'auxInfo',
    ChannelId: 'channelId',
    CreatedAt: 'createdAt',
    Deleted: 'deleted',
    DeletedAt: 'deletedAt',
    Email: 'email',
    EmailCode: 'emailCode',
    EmailCodeValidUntil: 'emailCodeValidUntil',
    EmailVerified: 'emailVerified',
    ExtProvider: 'extProvider',
    ExtToken: 'extToken',
    ExtUserId: 'extUserId',
    Id: 'id',
    IsAdmin: 'isAdmin',
    LastAccessedAt: 'lastAccessedAt',
    LastEventId: 'lastEventId',
    LastMesgNotiId: 'lastMesgNotiId',
    LastNoticeId: 'lastNoticeId',
    LastSysNotiId: 'lastSysNotiId',
    NewMessageDisplaySetting: 'newMessageDisplaySetting',
    NotiSetting: 'notiSetting',
    ReferChannelId: 'referChannelId',
    ReferrerId: 'referrerId',
    Tel: 'tel',
    Timestamp: 'timestamp'
};
exports.UserUsageScalarFieldEnum = {
    Data: 'data',
    Id: 'id'
};
exports.User_ChatRoomViewScalarFieldEnum = {
    ChatRoomId: 'chatRoomId',
    Filter: 'filter',
    Id: 'id',
    LastAccessedAt: 'lastAccessedAt',
    LastMessageId: 'lastMessageId',
    LastMessageSeq: 'lastMessageSeq',
    UpdatedAt: 'updatedAt',
    UserId: 'userId'
};
exports.User_ProfileScalarFieldEnum = {
    Access: 'access',
    Id: 'id',
    ProfileId: 'profileId',
    UserId: 'userId'
};
exports.VersionChangeScalarFieldEnum = {
    Break: 'break',
    Bugs: 'bugs',
    BugsEn: 'bugsEn',
    Changes: 'changes',
    ChangesEn: 'changesEn',
    Id: 'id',
    Version: 'version'
};
